import { ArrowUpRight, MessageCircle } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { SERVICES, wa, track } from "../../data/site";

export const Services = () => (
  <section id="servicos" className="py-20 lg:py-28" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        number="01"
        eyebrow="Serviços"
        title="Os nossos serviços"
        subtitle="Tratamos dos seus estofos com cuidado, profissionalismo e produtos adequados."
      />

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((service, i) => (
          <Reveal key={service.id} delay={(i % 3) * 0.08}>
            <article
              data-testid={`service-card-${service.id}`}
              className="group flex h-full flex-col overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-[0_4px_24px_rgba(11,25,44,0.05)] transition-all duration-500 hover:-translate-y-1.5 hover:border-brand/20 hover:shadow-[0_20px_50px_rgba(0,102,255,0.12)]"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/40 to-transparent" aria-hidden="true" />
                <span className="absolute bottom-3 left-3 grid h-10 w-10 place-items-center rounded-xl bg-white/90 shadow-lg backdrop-blur">
                  <service.icon className="h-5 w-5 text-brand" />
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="text-lg font-bold tracking-tight text-navy">{service.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-500">{service.desc}</p>
                <a
                  href={wa(`Olá! Vi o site da TopEstofos e gostaria de solicitar um orçamento para ${service.short}.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  id={`cta-servico-${service.id}`}
                  data-testid={`cta-servicos-whatsapp${i === 0 ? "" : `-${service.id}`}`}
                  data-event="service_click"
                  onClick={() => track("service_click", { service: service.id })}
                  className="cta-whatsapp service-whatsapp mt-5 inline-flex items-center gap-2 text-sm font-semibold text-brand transition-colors hover:text-brand-600"
                >
                  <MessageCircle className="h-4 w-4" />
                  Pedir orçamento
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
            </article>
          </Reveal>
        ))}

        <Reveal delay={0.16}>
          <a
            href={wa("Olá! Vi o site da TopEstofos e gostaria de pedir um orçamento para outro tipo de estofo.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-servicos-outro"
            data-event="whatsapp_click"
            onClick={() => track("whatsapp_click", { location: "services_other" })}
            className="cta-whatsapp group flex h-full min-h-[280px] flex-col items-start justify-between rounded-3xl bg-gradient-to-br from-navy to-navy-800 p-6 text-left shadow-xl shadow-navy/20 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-navy/30"
          >
            <span className="grid h-11 w-11 place-items-center rounded-2xl bg-white/10">
              <MessageCircle className="h-5 w-5 text-aqua" />
            </span>
            <div>
              <h3 className="text-lg font-bold text-white">Outro tipo de estofo?</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/70">
                Fale connosco no WhatsApp e diga-nos o que precisa de higienizar.
              </p>
              <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-aqua">
                Falar no WhatsApp
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </div>
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
